import { render, staticRenderFns } from "./TotalViewsToday.vue?vue&type=template&id=681f44a8&scoped=true"
import script from "./TotalViewsToday.vue?vue&type=script&lang=js"
export * from "./TotalViewsToday.vue?vue&type=script&lang=js"
import style0 from "./TotalViewsToday.vue?vue&type=style&index=0&id=681f44a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f44a8",
  null
  
)

export default component.exports